import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import logger from 'src/utils/logger/logger';

class SimpleCMMTask extends AbstractRequestTask {
  constructor(url, headers, middlewareVersion = '1.0.0') {
    super();
    this.url = url;
    this._config = getAppConfig();
    this._headers = headers;

    this.middlewareVersion = middlewareVersion;
    this.cm_access_token = this._headers.cm_access_token ? this._headers.cm_access_token : null;

    if(this._headers.cm_access_token) {
      delete this._headers.cm_access_token;
    }

    logger.debug('[MIGRATE] middlewareVersion: ' + middlewareVersion);
    // this._params = {
    //     ...params
    // };
  }

  getMethod() {
    return "GET";
  }

  getEncType() {
    return "application/x-www-form-urlencoded";
  }

  isValid(data) {
    if (
      data.errors &&
      !data.ribbons &&
      !data.albumDetail &&
      !data.playlistDetail
    ) {
      return false;
    }
    return true;
  }

  getUrl() {
    if(this.cm_access_token) {
      this.url = this.url + '&cm_access_token=' + this.cm_access_token;
    }

    return this.url;
  }

  getParams() {
    // const superParams = super.getParams();
    // return { ...this._params, ...superParams };
    return {  };
  }

  getHeaders() {
    return this._headers;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default SimpleCMMTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/SimpleCMMTask.js